import { useState, useEffect } from "react";
import { Switch } from "react-router-dom";
import AuthService from "services/AuthService";
import TeamService from "services/TeamService";
import Login from "views/Auth/Login/Login";
import * as microsoftTeams from "@microsoft/teams-js";
import { GlobalContext } from "store/contexts/globalContext";
import UnauthenticatedRoute from "components/UnAuthenticatedRoute";
import AuthenticatedRoute from "components/AuthenticatedRoute";
import { CredentialsContext } from "store/contexts/credentialsContext";
import GeneralService from "services/GeneralService";
import AIService from "services/AIService";
import { useUserContext } from "store/contexts/userContext";
import { useMoodsContext } from "store/contexts/moodsContext";
import "assets/scss/body.scss";
import ForgotPassword from "views/Auth/ForgotPassword/ForgotPassword";
import Register from "views/Auth/Register/Register";
import "react-responsive-modal/styles.css";
import Admin from "./Admin";
import TeamActions from "./TeamActions";
import VerifyAccount from "views/Auth/VerifyAccount/VerifyAccount";
import MSTeamsTabConfig from "views/Integrations/Teams/TabConfig";
import { useDispatch, useSelector } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import RingCentral from "./RingCentral";
import { deleteTheToken } from "services/FirebaseService";
import { useLocation } from "react-router-dom";
import { RcvEngineProvider } from "@ringcentral/video-sdk-react";
import RingCentralDragModal from "components/RingCentral/RingCentralDragModal/RingCentralDragModal";
import ApplauseIcon from "assets/img/applause.png";
import BotheredIcon from "assets/img/bothered.png";
import CheerfulIcon from "assets/img/cheerful.png";
import ConfusedIcon from "assets/img/confuse-unsure.png";
import LikeIcon from "assets/img/like-thumbs.png";
import checkInMood from "assets/img/check_in_mood_4.png";
import unHappySad from "assets/img/unhappy-sad.png";

export default () => {
  const dispatch = useDispatch();
  const { teams, searchedName, sortingOrder } = useSelector(
    (state) => state.teamsReducer
  );
  const [credentials, setCredentials] = useState();
  const { setUser, isAuthenticated, setIsAuthenticated } = useUserContext();
  const [teamsIosClient, setTeamsIosClient] = useState(false);
  const [microsoftConfigureTab, setMicrosoftConfigureTab] = useState(false);
  const { setMoods, setBuzzes } = useMoodsContext();
  const [teamsClient, setTeamsClient] = useState(false);
  const [rcvEngine, setRcvEngine] = useState(null);
  const [waterCoolerActivate, setWaterCoolerActivate] = useState(false);
  const [microsoftTeamsVideoText, setMicrosoftTeamsVideoText] = useState(false);
  const [isSafari, setIsSafari] = useState(false);
  const [chatId, setChatId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pollNotifications, setPollNotification] = useState(null);
  const search = useLocation().search;
  const param = new URLSearchParams(search);
  const [ringCentralToken, setRingCentralToken] = useState(null);
  const [zoomToken, setZoomToken] = useState();
  const [userData, setUserData] = useState();
  const [ringCentral] = useState(param.get("type") ? true : false);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [globalSearch, setGlobalSearch] = useState();
  const [aiAvatarData, setAiAvatar] = useState({
    id: null,
    data: {}
  });
  const [ringCentralData, setRingCentralData] = useState({
    modal: false,
    meeting_id: "",
    status: "",
  });

  useEffect(() => {
    if (!ringCentral) {
      return;
    }

    if (redirectUrl) {
      return;
    }

    setRedirectUrl(param.get("redirect"));

    //eslint-disable-next-line
  }, [param.get("redirect")]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const userData = localStorage.getItem("user");
    const parseUser = JSON.parse(userData);

    let ringcentralCred = parseUser.external_service_credentials && parseUser.external_service_credentials.find(
      (cred) => cred.external_service_id === 2
    );

    setUserData(parseUser);
    setRingCentralToken(ringcentralCred);

    (async () => {
      try {
        setLoading(true);

        const response = await Promise.all([
          GeneralService.getMoods(),
          GeneralService.getBuzz(),
          AIService.getAvatars().catch(() => ({ data: { data: [] } })),
          AIService.getSoundList().catch(() => ({ data: { data: [] } }))
        ]);

        let mData = [
          ...response[0].data.data,
        ]

        let newMData = [{...mData[0]}, {...mData[2], id: 2, name: "Inspired - on a roll"}, {...mData[1], id: 3, name:"All Good - Got This"}, {...mData[3], id: 4, media: checkInMood, name: "Need a team meeting"}, {...mData[4], id: 5, name: "Overwhelmed - Could use some help"}, {...mData[5], id: 6, name: "Feeling Disconnected"} ]
        setMoods(newMData);
        let buzData = [{ id: 12, name: "Agree", media: LikeIcon }, { id: 7, name: "Cheerful", media: CheerfulIcon }, { id: 8, name: "Applause", media: ApplauseIcon },
        { id: 10, name: "Bothered", media: BotheredIcon }, { id: 9, name: "Confused", media: ConfusedIcon }, { id: 11, name: "UnHappy", media: unHappySad }
        ]

        setBuzzes(buzData);
        await dispatch(timelineActions.getAllAvatars(response[2]?.data?.data || []));
        await dispatch(timelineActions.getAllSounds(response[3]?.data?.data || []));
      } catch (e) {
        console.log(e);
      } finally {
        getTeam();
      }
    })();
    //eslint-disable-next-line
  }, [isAuthenticated, setMoods, setBuzzes]);

  useEffect(() => {
    if (!microsoftTeams) {
      return;
    }

    if (
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
        (typeof safari !== "undefined" && window["safari"].pushNotification)
      )
    ) {
      setIsSafari(true);
    }

    // Initialize with Teams JS v2
    microsoftTeams.app.initialize().then(() => {
      microsoftTeams.app.notifySuccess();
      
      microsoftTeams.app.getContext().then((context) => {
        if (context === null && context === undefined) {
          return false;
        }

        if (context.chat?.id) {
          setChatId(context.chat.id);
        }

        if (context.app?.host?.clientType !== "web") {
          setMicrosoftTeamsVideoText(true);
        }

        if (context.app?.host?.clientType === "android") {
          setTeamsClient(true);
        }

        if (context.app?.host?.clientType === "ios") {
          setTeamsIosClient(true);
        }

        if (context.channel?.displayName || context.chat?.id || context.channel?.id) {
          setMicrosoftConfigureTab(context);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }
  }, [microsoftConfigureTab]);

  const handleLogout = async (e) => {
    e.preventDefault();
    await AuthService.logout();
    try {
      await deleteTheToken();
    } catch (e) {
      console.log(e);
    }
    dispatch(timelineActions.clearAllTeams());
    localStorage.clear();
    setGlobalSearch();
    setUser(null);
    setIsAuthenticated(false);
  };

  const getTeam = async () => {
    try {
      setLoading(true);
      const response = await TeamService.getAllTeams();
      dispatch(timelineActions.getAllTeams(response.data.data));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
  };

  const filterTeam = async ({ name = searchedName, sort = sortingOrder }) => {
    if (name) {
      dispatch(timelineActions.storeSearchTName(name));
    }

    if (sort) {
      dispatch(timelineActions.storeTSort(sort));
    }

    try {
      setLoading(true);
      const response = await TeamService.getAllTeams(name, sort);
      dispatch(timelineActions.getAllTeams(response.data.data));
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }

    setLoading(false);
  };

  const createTeam = async (newTeam) => {
    dispatch(timelineActions.createTeam(newTeam));
  };

  window.addEventListener("beforeunload", () => {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      return Promise.all(regs.map((reg) => reg.unregister()));
    });
  });

  const selectedTeam = async (teamId) => {
    var response = teams.filter((team) => team.id === JSON.parse(teamId));

    var teamData = { data: { data: response } };

    return teamData;
  };

  const updateTeam = async (team) => {
    try {
      await dispatch(timelineActions.updateTeam(team));
    } catch (e) {
      console.log(e);
    }
  };

  const checkYourTeamRole = async (team_id) => {
    var response = teams.find((team) => team.id === team_id);
    return response.role_id;
  };

  const deleteTeam = (deleteTeam) => {
    dispatch(timelineActions.deleteTeam(deleteTeam));
  };

  return (
    <CredentialsContext.Provider
      value={{
        credentials,
        setCredentials,
      }}
    >
      <GlobalContext.Provider
        value={{
          userData,
          setAiAvatar,
          aiAvatarData,
          setUserData,
          setRingCentralData,
          ringCentralData,
          setRcvEngine,
          rcvEngine,
          setGlobalSearch,
          setRingCentralToken,
          filterTeam,
          ringCentralToken,
          globalSearch,
          isSafari,
          chatId,
          selectedTeam,
          createTeam,
          updateTeam,
          microsoftTeamsVideoText,
          checkYourTeamRole,
          ringCentral,
          redirectUrl,
          setZoomToken,
          zoomToken,
          teamsIosClient,
          waterCoolerActivate,
          setWaterCoolerActivate,
          getTeam,
          deleteTeam,
          setPollNotification,
          microsoftConfigureTab,
          handleLogout,
          loading,
          teamsClient,
          pollNotifications,
        }}
      >
        <>
          <Switch>
            <UnauthenticatedRoute exact path="/login">
              <Login />
            </UnauthenticatedRoute>
            <UnauthenticatedRoute exact path="/register">
              <Register />
            </UnauthenticatedRoute>
            <UnauthenticatedRoute exact path="/forgot-password">
              <ForgotPassword />
            </UnauthenticatedRoute>
            <UnauthenticatedRoute exact path="/verify-account">
              <VerifyAccount />
            </UnauthenticatedRoute>
            <AuthenticatedRoute path="/ringcentral/teams/:teamId">
              <RingCentral />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/teams/:teamId">
              <TeamActions />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/integrations">
              <MSTeamsTabConfig />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/">
              <Admin />
            </AuthenticatedRoute>
          </Switch>
          {ringCentralData.modal && (
            <RcvEngineProvider rcvEngine={rcvEngine}>
              <RingCentralDragModal />
            </RcvEngineProvider>
          )}
        </>
      </GlobalContext.Provider>
    </CredentialsContext.Provider>
  );
};
